<template>
  <modal :value="value"
         width="800"
         @input="hideModal"
         content-class="modal modal-round">       

    <locals-creation-form-body ref="body"
                               v-model="form"
                               :show="show"                              
                               @valid="save" />

    <div class="card-footer">
      <button class="btn btn-primary btn-round"
              @click="validate()">
        {{$t('message.generics.message.save')}}
      </button>
    </div>

  </modal>
</template>

<script>
import LocalsCreationFormBody from "@views/locals/components/LocalsCreationFormBody";
import EventBus from "@packages/event-bus/index";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    LocalsCreationFormBody,
    Modal,
  },

  data() {
    return {
      show: false,
      form: {},
      isEdit: false,
      updateId: undefined,
    };
  }, 

  async mounted() {
    this.reset()
  },

  props: {
    node: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false
    },    
  },

  computed: {},

  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },
    hideModal() {
      this.emitInput(false);
    },
    reset() {
      this.form = {
        checkAge: false,
        timeoutType: "HORA",
        blockTimeoutUnit: "HORA",
        timezone: "America/Sao_Paulo",
      };
    },
    async edit(id) {
      const local = await this.$api.locals.get(id);

      this.updateId = id;

      this.form = {
        name: local.nome,
        zipcode: local.cep,
        timezone: local.timezone,
        state: local.estado,
        city: local.cidade,
        neighborhood: local.bairro,
        extra: local.complemento,
        streetName: local.logradouro,
        streetNumber: local.numero,
        timeoutType: local.unidadeTimeout,
        timeout: local.timeout,
        checkAge: local.isSomenteMaiorIdade,
        grupoId: local.grupoId,
        notes: local.notes,
        apControllerId: local.apControllerId,
        blockTimeoutUnit: local.blockTimeoutUnit,
        blockTimeout: local.blockTimeout,
        category: local.category,
        requireMessageAuthenticator: local.requireMessageAuthenticator
      };
      this.isEdit = true;
    },
    validate() {
      this.$refs.body.validate();
    },
    async save() {
      EventBus.$emit("SHOW_SPINNER");

      try {
        if (!this.isEdit) {
          const data = {
            nome: this.form.name,
            cep: this.form.zipcode,
            timezone: this.form.timezone,
            estado: this.form.state,
            cidade: this.form.city,
            bairro: this.form.neighborhood,
            logradouro: this.form.streetName,
            numero: this.form.streetNumber,
            complemento: this.form.extra,
            unidadeTimeout: this.form.timeoutType,
            timeout: this.form.timeout,
            isSomenteMaiorIdade: this.form.checkAge,
            notes: this.form.notes,
            apControllerId: this.form.apControllerId,
            grupoId: null,
            blockTimeoutUnit: this.form.blockTimeoutUnit,
            blockTimeout: this.form.blockTimeout,
            category: this.form.category,
            requireMessageAuthenticator: this.form.requireMessageAuthenticator
          };

          if (this.node && this.node.tipo === "GRUPO_LOCAL") {
            data.grupoId = this.node.id;
          }

          const newLocal = await this.$api.locals.create(data);

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.spotCreated'),
            timeout: 2000,
          });

          this.$emit("created", { ...newLocal, tipo: "LOCAL" });
        } else {
          const updatedLocale = await this.$api.locals.update({
            id: this.updateId,
            data: {
              nome: this.form.name,
              cep: this.form.zipcode,
              timezone: this.form.timezone,
              estado: this.form.state,
              cidade: this.form.city,
              bairro: this.form.neighborhood,
              logradouro: this.form.streetName,
              numero: this.form.streetNumber,
              complemento: this.form.extra,
              unidadeTimeout: this.form.timeoutType,
              timeout: this.form.timeout,
              isSomenteMaiorIdade: this.form.checkAge,
              grupoId: this.form.grupoId,
              notes: this.form.notes,
              apControllerId: this.form.apControllerId,
              blockTimeoutUnit: this.form.blockTimeoutUnit,
              blockTimeout: this.form.blockTimeout,
              category: this.form.category,
              requireMessageAuthenticator: this.form.requireMessageAuthenticator
            },
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.spotEdited'),
            timeout: 2000,
          });

          EventBus.$emit("UPDATE_NODE", { ...updatedLocale, tipo: "LOCAL" });

          this.isEdit = false;
        }

        this.hideModal()
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 160px;
}
</style>
